import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import { CookieService } from 'ngx-cookie-service';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;


@Component({
	selector: 'app-like-activity-report',
	templateUrl: './like-activity-report.component.html',
	styleUrls: ['./like-activity-report.component.css']
})
export class LikeActivityReportComponent implements OnInit {
	surveyForm: any;
	surveyList: any;
	stateList: any;
	cityList: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	countryList: any = [];
	base64textString: any;
	attached_image: any;
	flashMsg: string;
	selectedSurveyData: any;
	// selectedSurveyId: any;
	// surveyExpiryList: any;
	surveyCategoryList: any;
	url: any;
	surveyType: any;
	isDeleteSurvey: boolean;
	deleteSelectedSurveyData: any;
	searchStr: any = "";
	surveyCategory: any = "";
	surveyStatus: any = "";
	activePageNo: number = 0;
	userList: any = [];

	constructor(
		private commonService: CommonService,
		private authService: AuthService,
		private router: Router,
		private validationService: ValidationService,
		private pagerService: PagerService,
		private cookieService: CookieService) { }

	ngOnInit() {
		this.initialiseLikeActivity();
		this.commonService.process();
		$(".navbar-brand").text("Like Activity Report");

		this.authService.getCountryList().subscribe(data => {
			if (data.success) {
				this.countryList = data.country;
			}
		});
	}


	initialiseLikeActivity = function () {
		this.commonService.setTitle();
		this.limit = 10;
		this.pageNo = 1;
		this.url = '';
		this.surveyStatus = 0;

		// this.authService.getSurveyExpiryList().subscribe(data => {
		// 	if (data.success) {
		// 		this.surveyExpiryList = data.time;
		// 	}
		// });

		this.authService.getUser().subscribe(data => {
			if (data.success) {
				this.userList = data.userList;
			} else {
				this.userList = [];
			}
		});



		// Get survey category list
		this.authService.getSurveyCategoryList().subscribe(data => {
			if (data.success) {
				var that = this;
				this.surveyCategoryList = data.category;
				setTimeout(function () {
					$("#surveyCategory").val(that.surveyCategory);
					$("#surveyStatus").val(that.surveyStatus);
					$("#search").val(that.searchStr);
					$('#page_' + that.activePageNo).addClass('active');
					if (that.activePageNo == 1)
						$('#first, #prev').addClass('disabled');
					else if (that.activePageNo == that.pager.totalPages)
						$('#next, #last').addClass('disabled');
				}, 300);
			}
		});

		// Get survey list
		this.getLikeActivityRepoort(this.pageNo, this.limit);


	}

	// Get survey list
	getLikeActivityRepoort = function (pageNo, limit,str='') {

		this.commonService.process();

		this.authService.getLikeActivityRepoort(pageNo, limit,str).subscribe(data => {

			if (data.success) {
				this.isSurveyAvailable = false;
				this.surveyList = data.userList;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
				console.log(this.total);

			} else {
				this.surveyList = [];
				this.isSurveyAvailable = true;
			}
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {

		$('.pages.active a').each(function () {
			if (parseInt($(this).text()) != page)
				$(this).parent('li').removeClass('active');
		});
		if ($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
			$('#first, #prev').removeClass('disabled');
		if ($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
			$('#next, #last').removeClass('disabled');

		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		this.pager = this.pagerService.getPager(this.total, page);
		// get current page of items
		this.pagedItems = this.surveyList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getLikeActivityRepoort(page, this.limit);
		}
	}

	// Search survey
	searchSurvey = function () {

		var start_date = $("#start_date").val();
		var end_date = $("#end_date").val();
		var country = $("#country").val();
		var favorite = $("#favorite").val();
		var response = $("#response").val();
		var surveylike = $("#surveylike").val();
		var user_id = $("#user_id").val();


		var obj = {
			'myResponse': response,
			'startDate': start_date,
			'endDate': end_date,
			'country_id': country,
			'myFavorite': favorite,
			'mySurvey': surveylike,
			'user_id': user_id
		}

		var str = [];
		for (var p in obj){
			console.log(obj[p]);
			if (obj.hasOwnProperty(p) && obj[p]) {
				str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
			}
		}

        console.log(str.join("&"));

		this.getLikeActivityRepoort(1, this.limit,str.join("&"));
	}


}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/like-activity-report/like-activity-report.component.ts